import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { RolesEnum } from '../enums/roles-enum';
import { GlobalAuthService } from '../services/global-auth.service';
import { RolesService } from '../services/roles.service';

/**
 * Guard that ensures Account Managers have selected a site before accessing non-admin routes
 * Account Managers should be redirected to site selection if they haven't selected a site
 * and are trying to navigate away from the admin portal
 */
export const accountManagerSiteSelectionGuard: CanActivateFn = (route, state) => {
  const authService = inject(GlobalAuthService);
  const rolesService = inject(RolesService);
  const router = inject(Router);

  const isAccountManager = rolesService.hasRoles([RolesEnum.AccountManager]);
  
  if (!isAccountManager) {
    return true;
  }

  if (state.url.startsWith('/admin')) {
    return true;
  }
  if (state.url.startsWith('/settings/site')) {
    return true;
  }

  const selectedSiteId = authService.selectedSite();
  const storedSiteId = localStorage.getItem('selectedSite');
  const hasSelectedSite = !!selectedSiteId || !!storedSiteId;
  
  if (!hasSelectedSite) {
    // No site selected, redirect to site selection
    router.navigate(['/settings/site'], { 
      queryParams: { returnUrl: state.url },
      replaceUrl: true 
    });
    return false;
  }

  return true;
};
